import {
    HR_PRODUCT,
    HR_PRODUCT_SUCCESS,
    HR_PRODUCT_ERROR,
    HR_PRODUCT_LIST,
    HR_PRODUCT_LIST_SUCCESS,
    HR_PRODUCT_LIST_ERROR,
    HR_SUPPLIER,
    HR_SUPPLIER_SUCCESS,
    HR_SUPPLIER_ERROR,
    HR_CATEGORY,
    HR_CATEGORY_SUCCESS,
    HR_CATEGORY_ERROR,
    HR_COUNTRY,
    HR_COUNTRY_SUCCESS,
    HR_COUNTRY_ERROR,
    HR_STATUS,
    HR_STATUS_SUCCESS,
    HR_STATUS_ERROR,
    HR_LIST,
    HR_LIST_SUCCESS,
    HR_LIST_ERROR,
    HR_LIST_SEARCH_CHANGE,
    HR_LIST_PAGE_SET,
    HR_ADD_MODAL_SET,
    HR_ADD_CHANGE_SET,
    HR_ADD,
    HR_ADD_SUCCESS,
    HR_ADD_ERROR,
    HR_EDIT_MODAL_SET,
    HR_EDIT_CHANGE_SET,
    HR_EDIT,
    HR_EDIT_SUCCESS,
    HR_EDIT_ERROR,
    HR_UPLOAD_SET,
    HR_UPLOAD_SET_SUCCESS,
    HR_UPLOAD_SET_ERROR,
    HR_UPLOAD_RESET,
} from "../../actions";

const INIT_STATE = {
    loading: false,
    list: {
        page: {
            current: 1,
            rows: 10
        }
    },
    product: {
        loading: false,
        data: []
    },
    productlist: {
        loading: false,
        data: []
    },
    supplier: {
        loading: false,
        data: []
    },
    category: {
        loading: false,
        data: []
    },
    country: {
        loading: false,
        data: []
    },
    status: {
        loading: false,
        data: []
    },
    add: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    edit: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    file: [],
    error: false,
    search: {
        modal: false,
        init: true,
        data: {
            product: '',
            supplier: '',
            category: '',
            status: ''
        },
        value: {
            product: '',
            supplier: '',
            category: '',
            status: ''
        }
    }
};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case HR_PRODUCT:
            return {
                ...state,
                loading: true,
                product: {
                    ...state.product
                }
            }
        case HR_PRODUCT_SUCCESS:
            return {
                ...state,
                loading: false,
                product: {
                    ...state.product,
                    ...action.payload
                }
            }
        case HR_PRODUCT_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case HR_PRODUCT_LIST:
            return {
                ...state,
                loading: true,
                productlist: {
                    ...state.productlist
                }
            }
        case HR_PRODUCT_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                productlist: {
                    ...state.productlist,
                    ...action.payload
                }
            }
        case HR_PRODUCT_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case HR_SUPPLIER:
            return {
                ...state,
                loading: true,
                supplier: {
                    ...state.supplier
                }
            }
        case HR_SUPPLIER_SUCCESS:
            return {
                ...state,
                loading: false,
                supplier: {
                    ...state.supplier,
                    ...action.payload
                }
            }
        case HR_SUPPLIER_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case HR_CATEGORY:
            return {
                ...state,
                loading: true,
                category: {
                    ...state.category
                }
            }
        case HR_CATEGORY_SUCCESS:
            return {
                ...state,
                loading: false,
                category: {
                    ...state.category,
                    ...action.payload
                }
            }
        case HR_CATEGORY_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case HR_COUNTRY:
            return {
                ...state,
                loading: true,
                country: {
                    ...state.country
                }
            }
        case HR_COUNTRY_SUCCESS:
            return {
                ...state,
                loading: false,
                country: {
                    ...state.country,
                    ...action.payload
                }
            }
        case HR_COUNTRY_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case HR_STATUS:
            return {
                ...state,
                loading: true,
                status: {
                    ...state.status
                }
            }
        case HR_STATUS_SUCCESS:
            return {
                ...state,
                loading: false,
                status: {
                    ...state.status,
                    ...action.payload
                }
            }
        case HR_STATUS_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case HR_LIST:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list
                }
            }

        case HR_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case HR_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        case HR_LIST_PAGE_SET:
            return {
                ...state,
                list: {
                    ...state.list,
                    page: {
                        ...state.list.page,
                        ...action.payload,
                    }
                }
            }
        case HR_LIST_SEARCH_CHANGE:
            return {
                ...state,
                search: {
                    ...state.search,
                    data: action.payload,
                }
            }
        case HR_ADD_MODAL_SET:
            return {
                ...state,
                add: {
                    ...state.add,
                    modal: action.payload
                }
            }
        case HR_ADD_CHANGE_SET:
            return {
                ...state,
                add: {
                    ...state.add,
                    data: {
                        ...state.add.data,
                        ...action.payload
                    }
                }
            }
        case HR_ADD:
            return {
                ...state,
                add: {
                    ...state.add,
                    loading: false
                }
            }
        case HR_ADD_SUCCESS:
            return {
                ...state,
                add: {
                    ...state.add,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case HR_ADD_ERROR:
            return {
                ...state,
                add: {
                    ...state.add,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case HR_EDIT_MODAL_SET:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    modal: action.payload
                }
            }
        case HR_EDIT_CHANGE_SET:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    data: {
                        ...state.edit.data,
                        ...action.payload
                    }
                }
            }
        case HR_EDIT:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    loading: false
                }
            }
        case HR_EDIT_SUCCESS:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case HR_EDIT_ERROR:
            return {
                ...state,
                edit: {
                    ...state.edit,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case HR_UPLOAD_SET:
            return { ...state };

        case HR_UPLOAD_SET_SUCCESS:
            return {
                ...state,
                file: { ...state.file, ...action.payload }
            };

        case HR_UPLOAD_SET_ERROR:
            return {
                ...state,
                file: { ...state.file, ...action.payload }
            };

        case HR_UPLOAD_RESET:
            return {
                ...state,
                file: []
            };


        default:
            return { ...state };
    }
};